const subscriptionTypes = require('./subscriptions-types');
const pricing = require('./pricing');

module.exports = {
  subscriptionTypes,
  pricing,
};
